import { BuildingIcon, CheckIcon, UserIcon } from '@/components/ui/icons';
import { MOTION } from '@/utils';
import { PRICING_FEATURE_GROUPS, PRICING_PLANS } from '@/utils/data/princingFunctions';
import { useGSAP } from '@gsap/react';
import { gsap } from 'gsap';
import { useRef } from 'react';

const cabinetPlan = PRICING_PLANS.find((p) => p.id === 'cabinet')!;
const collaborateurPlan = PRICING_PLANS.find((p) => p.id === 'collaborateur')!;

export default function ComparisonTable() {
  const refs = {
    section: useRef<HTMLElement>(null),
    container: useRef<HTMLDivElement>(null),
  };

  useGSAP(
    () => {
      if (!refs.section.current) return;

      gsap
        .timeline({
          defaults: { duration: MOTION.durationMd, ease: MOTION.ease },
          scrollTrigger: {
            trigger: refs.section.current,
            start: 'top 65%',
            toggleActions: 'play none none reverse',
          },
        })
        .from(refs.container.current, { autoAlpha: 0, y: MOTION.y });
    },
    { scope: refs.section },
  );

  return (
    <section ref={refs.section} className="max-width-white-section" id="tarif-comparaison">
      <div className="max-width-white-section-content">
        <div ref={refs.container} className="overflow-x-auto">
          <div>
            {/* En-tête */}
            <div className="border-dark-blue/8 grid grid-cols-[1fr_6rem_6rem] border-b px-4 pb-3 md:grid-cols-[25rem_1fr_1fr]">
              <div />
              <div className="flex flex-col items-center gap-0.5">
                <div className="bg-orange mb-1 rounded-md p-1.5 text-white">
                  <BuildingIcon />
                </div>
                <span className="text-dark-blue font-roboto-medium text-sm">Cabinet</span>
                <span className="text-orange text-xs">{cabinetPlan.price}&nbsp;€/mois</span>
              </div>
              <div className="flex flex-col items-center gap-0.5">
                <div className="bg-dark-blue/8 text-dark-blue mb-1 rounded-md p-1.5">
                  <UserIcon />
                </div>
                <span className="text-dark-blue font-roboto-medium text-sm">Collaborateur</span>
                <span className="text-dark-blue/50 text-xs">
                  {collaborateurPlan.price}&nbsp;€/mois
                </span>
              </div>
            </div>

            {/* Groupes */}
            {[...PRICING_FEATURE_GROUPS]
              .sort((a, b) => (b.collabBadge ? 1 : 0) - (a.collabBadge ? 1 : 0))
              .map((group) => (
                <div key={group.id}>
                  <div className="bg-dark-blue/3 grid grid-cols-[1fr_6rem_6rem] px-4 py-2 md:grid-cols-[25rem_1fr_1fr]">
                    <span className="text-dark-blue/45 font-roboto-medium text-xs tracking-wide uppercase md:ml-10">
                      {group.label}
                    </span>
                    <div />
                    <div />
                  </div>

                  {group.features.map((feature) => (
                    <div
                      key={feature.label}
                      className="border-dark-blue/5 hover:bg-orange/3 grid grid-cols-[1fr_6rem_6rem] border-b px-4 py-2 transition-colors md:grid-cols-[25rem_1fr_1fr]"
                    >
                      <span className="text-dark-blue/70 text-sm md:ml-20">{feature.label}</span>
                      <div className="flex items-center justify-center">
                        <CheckIcon />
                      </div>
                      <div className="flex items-center justify-center">
                        {feature.inCollaborateur ? (
                          <CheckIcon />
                        ) : (
                          <span className="text-dark-blue/20 text-sm font-light">—</span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
}
